import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";
import { NoteDeFraisView } from "@/features/rh/notes-de-frais/components/NoteDeFraisView";

export const Route = createFileRoute("/_app/(dashboard)/frais/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS.VIEW),
  staticData: {
    title: "Voir une note de frais",
    icon: Eye,
    permission: PERMISSIONS.RH.FRAIS.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: () => (
    <NoteDeFraisView routeFrom="/_app/(dashboard)/frais/$id/view" backTo="/frais/me" />
  ),
});
